import React from 'react'
import { useEffect } from "react";
import StocksContext from '../../../contexts/StocksContext'
import StatusContext from '../../../contexts/StatusContext';
import AuthContext from '../../../contexts/AuthContext';
import { Row, Col } from 'react-bootstrap';

import './stockstemplates.css'
import { NavBarStocks } from '../../main/navbarstocks/NavBarStocks'
import { ProgressIcon } from '../customicons/ProgressIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'
import Prompts from '../prompts/Prompts'
import {ResponseDisplayTemplates} from "../responsedisplay/ResponseDisplayTemplates"
import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import {LoginDialog} from '../logindialog/LoginDialog'
import { DialogNewPrompt } from './DialogNewPrompt';
import { DialogPreview } from './DialogPreview';
import { WaitonResponse } from '../waitonresponse/WaitonResponse';
import AIButton from '../aibutton/AIButton';
import { DialogSelectModels } from '../aibutton/DialogSelectModels';
import { CustomTooltip } from '../customtooltip/CustomTooltip';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { StockPrices } from './StockPrices';
import { DialogSymbols } from './DialogSymbols';
import { ArrowUpward, ArrowDownward} from "@mui/icons-material"
import {RadioButtonsPrice } from './RadioButtonsPrice'
import { DialogProgress } from './DialogProgress';
import { Analyze } from './Analyze';
import { FastAnalysis } from './FastAnalysis';
import {Symbols} from './Symbols';


export const StocksTemplates = () => {

  const mediaQuery = window.matchMedia('(max-width: 500px)');
  const isMobile = mediaQuery.matches;

  let {

    prompt,
    onClearPrompts,
    onClearResponse,
    onPreview,
   
    promptsAvailable,

    changePrompt,
    deletePrompt,
    moveupPrompt,
    movedownPrompt,
    prompts,
    //promptareaRef,
    allresponses,
    onAcceptDeleteResponse,
    onCancelDeleteResponse,
    onDeleteResponse,
    changeWho,
    setShowNewPromptDialog,
    setEditMode,
   
    arrowRight,
    setArrowRight,
    arrowLeft,
    setArrowLeft,
    arrowSplit,
    setArrowSplit,
    getPrices,

    stockPrices,
    showHistoricalPrices,
    setShowHistoricalPrices,

    status,
    
    onEditMode,

    closeDialogBoxPrices,
    openDialogPrices,

    closeDialogBoxAnalyze,
    openDialogAnalyze,

    
    closeDialogBoxFastAnalyze,
    openDialogFastAnalyze,

    closeDialogBoxDeleteSymbolsGroup,
    openDialogDeleteSymbolsGroup,

    onSubmit,
    onFastAnalysis,

    deleteSymbolsGroup,

    showRules,
    setShowRules,
    onLoadSymbols

  } = React.useContext(StocksContext);

  let {
    isMe,
    scrollRef,
    isLoading,
    changeLanguageEnglish,
    openDialog,
    openDialogResponse,
    openDialogBox,
    closeDialogBox,
    openDialogBoxResponse,
    closeDialogBoxResponse,
    setShowLoginDialog,
    getAIModel,
    getAIProvider,
    onClickAIButton,

  } = React.useContext(StatusContext);

  const {
    checkCurrentUser,
} = React.useContext(AuthContext);


useEffect(() => {
  console.log("Stocks useEffect")
  onLoadSymbols();
}, [onLoadSymbols])   

const handleShowRules = () => {
  setShowRules(!showRules)
}

const handleHistoryData = () => {
  setShowHistoricalPrices(!showHistoricalPrices)
}

  const alertYes = () => {
    onClearPrompts()
    closeDialogBox()
}

const alertCancel = () => {
  closeDialogBox()
}

const alertYesResponses = () => {
  onClearResponse()
  closeDialogBoxResponse()
}

const alertCancelResponse = () => {
  closeDialogBoxResponse()
}

const alertYesPrices = () => {
  
  closeDialogBoxPrices()
  getPrices(true)
}

const alertCancelPrices = () => {
  closeDialogBoxPrices()
}

const alertYesFastAnalyze = () => {
  
  closeDialogBoxFastAnalyze()
  onFastAnalysis(true)
}

const alertCancelFastAnalyze = () => {
  closeDialogBoxFastAnalyze()
   onFastAnalysis(false)
}

const alertYesAnalyze = () => {
  
  closeDialogBoxAnalyze()
  onSubmit(true)
}

const alertCancelAnalyze = () => {
  closeDialogBoxAnalyze()
   onSubmit(false)
}

const alertYesDeleteSymbolsGroup = () => {
  deleteSymbolsGroup()
}

const alertCancelDeleteSymbolsGroup = () => {
  closeDialogBoxDeleteSymbolsGroup()
}

  const onNewPrompt = () => {
    if (checkCurrentUser() === false)
      {
        setShowLoginDialog(true)
        return;
      }
    setEditMode(false)
    setShowNewPromptDialog(true)
    
  }

  const handleArrowLeft = () => {
    setArrowRight(false)
    setArrowLeft(true)
    setArrowSplit(false)
  }

  const handleArrowRight = () => {
    setArrowLeft(false)
    setArrowRight(true)
    setArrowSplit(false)
  }

  const handleArrowSplit = () => {
    console.log("OnSplit")
    setArrowLeft(false)
    setArrowRight(false)
    setArrowSplit(true)
  }

  return (

    <div className="homeContainer">
      
    <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>

      <>
        {
          (!isMobile) ?
            <div >
              <NavBarStocks title={changeLanguageEnglish('stocks', 'navbartitle')} />
              
                <Row >
                   {
                  
                      <Stack direction="row" spacing={2}>
                        <>
                          <CustomTooltip title={changeLanguageEnglish('stocks', 'rules')}>
                            <span><ArrowCircleLeftIcon  className='arrowCircle' disabled={arrowLeft} onClick={handleArrowLeft}/></span>
                          </CustomTooltip>  
                          <CustomTooltip title={changeLanguageEnglish('stocks', 'responses')}>
                            <span> <ArrowCircleRightIcon  className='arrowCircle' disabled={arrowRight} onClick={handleArrowRight}/></span>
                          </CustomTooltip>
                          <CustomTooltip title={changeLanguageEnglish('stocks', 'notesandresponses')}>
                            <span><SyncAltIcon className='arrowCircle' disabled={arrowRight} onClick={handleArrowSplit}/></span>
                          </CustomTooltip>
                        
                        </>
                        </Stack>
                    }

                  {
                    (arrowLeft || arrowSplit) &&
                  <Col style={{marginLeft: arrowSplit ? '0%' : '10%', marginRight: arrowSplit ? '0%' : '10%'}}>
                    <label className='labelTitle'>{changeLanguageEnglish('stocks', 'rules')} </label>
                    <div className="templatesPromptArea">
                      <Prompts prompts={prompts} onDelete={deletePrompt} onChange={changePrompt} onChangeWho = {changeWho} onMoveUp={moveupPrompt} onMoveDown={movedownPrompt} onEdit={onEditMode}/>
                    </div>
                
               
                    <div  className="mainButtons">
                      <div>
                       
                        <Stack direction="row" spacing={2}>
                          {
                            (promptsAvailable) &&
                            <>
                            <CustomTooltip title={changeLanguageEnglish('stocks', 'addtooltip')}>
                              <span>
                                <PushButton onClick={onNewPrompt} label =  {changeLanguageEnglish('stocks','add')}/>
                              </span>
                            </CustomTooltip>
                             </>
                          }

                          {
                            (promptsAvailable) && 
                            <>
                              <CustomTooltip title={changeLanguageEnglish('stocks', 'previewtooltip')}>
                                <span>
                                <PushButton onClick={onPreview} label =  {changeLanguageEnglish('stocks','preview')}/> 
                                </span>
                              </CustomTooltip>

                              <PushButton onClick={openDialogBox} label =  {changeLanguageEnglish('stocks','clearall')}/>
                           
                            </>             
                          }

                      
                          {
                            (!promptsAvailable) &&
                            <>
                            <CustomTooltip title={changeLanguageEnglish('stocks', 'createtemplatetooltip')}>
                            <span>
                              <PushButton onClick={onNewPrompt} label =  {changeLanguageEnglish('stocks','createtemplate')}/>
                            </span>
                            </CustomTooltip>
                            </>
                          }

                         </Stack >
                          
                          <br></br>
                        
                        
                      </div>
                    </div>
                    
                
               
                   
                  </Col>
                  }

                  {
                    (arrowRight || arrowSplit) &&
                  <Col style={{marginLeft: arrowSplit ? '0%' : '10%', marginRight: arrowSplit ? '0%' : '10%'}}>
                
                    <label className='labelTitle'> {changeLanguageEnglish("stocks", "responses")} </label>
                    <div className="templatesPromptArea" ref={scrollRef}>
                      <span style={{ color: 'rgb(199, 178, 178)' }}>{prompt}</span>

                      <div>
                        {
                            Array.isArray(allresponses) &&
                            allresponses.map((item) => (
                                <ResponseDisplayTemplates key= {item.id} displayprompt = {item} 
                                onCancelDelete = {onCancelDeleteResponse} onAcceptDelete= {onAcceptDeleteResponse} onDeletePrompt = {onDeleteResponse}/>
                                ))
                        }
                    </div>
                    {
                      (!status) &&
                        <WaitonResponse />
                    }   
                    </div>
                         
                 
                    <div className='mainButtons' style = {{marginTop:'-8px'}}>
                      <div>
                        <PushButton onClick={openDialogBoxResponse} label =  {changeLanguageEnglish('stocks','clearall')}/>
                      </div>

                     <AvailableCredits />
                    </div>
                  </Col>

                  }


                  {
                    <div style={{marginLeft: arrowSplit ? '0%' : '10%', marginRight: arrowSplit ? '0%' : '10%'}}>
                      <div style={{width:'50%'}}>
                      
                         <Symbols />
                        <br></br>
                       
                          <label style={{marginTop:'10px', marginBottom:'0px', fontWeight:'bold'}}>HISTORICAL PRICES:</label>
                          <Stack direction="row" spacing={2} >
                            <RadioButtonsPrice />
                          </Stack>
                          <br></br>
                          <br></br>
                          <Analyze />

                          <label><span style={{margin:'-5px', fontSize:'16px', fontWeight:'500'}}>DISCLAIMER: &nbsp;</span> {changeLanguageEnglish("stocks", "disclaimer")}</label>
                        
                         <br></br>

                          { 
                          isMe() &&
                          <>
                            <br></br>
                          
                            <FastAnalysis />
                           
                            <br></br>
                          </>
                          }
                          
                      {
                      (status) && 
                        <label className='statusLabel'>{status}</label>
                      }

                         {
                    
                      <>
                      <Stack direction="row" spacing={2}>
                        {
                          showHistoricalPrices ?
                            <ArrowUpward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={handleHistoryData} />
                          :
                            <ArrowDownward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={handleHistoryData} />
                      }
                       <label style={{margin:'-5px', fontSize:'22px'}}>{changeLanguageEnglish("stocks", "historicaldata")}</label>
                        <br></br>
                        <br></br>
                        </Stack>
                        {
                          (showHistoricalPrices && stockPrices.length > 0) &&
                          <div className="templatesPromptArea"> 
                              <div style={{ width: !isMobile ? '100%' : '100%',  height: '100%', fontSize:'12px' }}
                                  className="ag-theme-quartz" >
                                  <StockPrices />
                              </div>
                          </div>
                        }
                  
                    </>
                    }
                        
                    </div>
                    </div>
                  }
                  
                </Row>
            
            </div>

            :

            <div>
              <NavBarStocks title={changeLanguageEnglish('stocks', 'navbartitle')} />
               <Stack direction="row" spacing={0}>
                  {
                    showRules ?
                      <ArrowUpward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={handleShowRules} />
                      :
                      <ArrowDownward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={handleShowRules} />
                  }
                <label style={{color:'maroon', fontWeight:'500'}}>{changeLanguageEnglish('stocks', 'rules')} </label>
              </Stack>

              {
                showRules && 
                <>
                <div className="templatesPromptArea">
                  <Prompts prompts={prompts} onDelete={deletePrompt} onChange={changePrompt} onChangeWho = {changeWho} onMoveUp={moveupPrompt} onMoveDown={movedownPrompt} onEdit={onEditMode}/>
                </div>
           
                <div className="mainButtons">
                  <div>
                    <Stack direction="row" spacing={2}>
                    {
                      (promptsAvailable) && 
                          <>
                          <PushButton onClick={openDialogBox} label =  {changeLanguageEnglish('stocks','clearall')}/>
                          <PushButton onClick={onPreview} label =  {changeLanguageEnglish('stocks','preview')}/>
                          <PushButton onClick={onNewPrompt} label =  {changeLanguageEnglish('stocks','add')}/>
                          </>
                    }

                    {
                      (!promptsAvailable) &&
                        <PushButton onClick={onNewPrompt} label =  {changeLanguageEnglish('stocks','createtemplate')}/>
                    }

                    </Stack>
                  </div>
    
                </div>
                </>
            }

              <hr></hr>
              <Symbols />
              
              <br></br>
                <label style={{marginTop:'10px', marginBottom:'0px', color:'blue', fontWeight:'bold'}}>HISTORICAL PRICES:</label>
                <Stack direction="row" spacing={2}>
                  {/*<PushButton onClick={onGetPrices} label =  {changeLanguageEnglish('stocks','getprices')}/>*/}
                  <RadioButtonsPrice />
                </Stack>
                <br></br>
              
              <Analyze />
              <label><span style={{margin:'-5px', fontSize:'14px', fontWeight:'500'}}>DISCLAIMER: &nbsp;</span> <span style={{fontSize:'14px'}}>{changeLanguageEnglish("stocks", "disclaimer")}</span></label>
             <br></br>

             { 
                isMe() &&
                  <>
                    <br></br>
                 
                    <FastAnalysis />
                    
                    <br></br>
                  </>
              }

              <div>
                {
                    (status) && <label className='statusLabel'>{status}</label>
                }
              </div>
             
              <label className='labelTitle'>{changeLanguageEnglish('stocks', 'responses')} </label>
                <div className="templatesPromptArea" ref={scrollRef}>
                  <span style={{ color: 'rgb(199, 178, 178)' }}>{prompt}</span>
                  <div>
                          {
                              Array.isArray(allresponses) &&
                              allresponses.map((item) => (
                                  <ResponseDisplayTemplates key= {item.id} displayprompt = {item} 
                                  onCancelDelete = {onCancelDeleteResponse} onAcceptDelete= {onAcceptDeleteResponse} onDeletePrompt = {onDeleteResponse}/>
                                  ))
                          }
                  </div>

                  {
                    !status && <WaitonResponse />
                  }
                </div>

              <div className='mainButtons'>
                <div className='flex-container'>
                   
                  <Stack direction="row" spacing={2}>
                  <PushButton onClick={openDialogBoxResponse} label =  {changeLanguageEnglish('stocks','clearresponses')}/>
                  </Stack>
                </div>

               <AvailableCredits />

              </div>

              
                 {
                    
                      <>
                      <Stack direction="row" spacing={2}>
                        {
                          showHistoricalPrices ?
                            <ArrowUpward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={handleHistoryData} />
                          :
                            <ArrowDownward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={handleHistoryData} />
                        }  
                       <label style={{margin:'-5px', fontSize:'22px'}}>{changeLanguageEnglish("stocks", "historicaldata")}</label>
                        <br></br>
                        <br></br>
                      </Stack>
                        {
                          (showHistoricalPrices && stockPrices.length > 0) &&
                          <div className="templatesPromptArea"> 
                              <div className="ag-theme-quartz" style={{ width: '100%', height: '100%', fontSize:'12px'}}>
                                  <StockPrices />
                              </div>
                          </div>
                        }
                  
                    </>
                    }
             
            </div>
        }
      </>

      <ProgressIcon isLoading={isLoading} />
      <LoginDialog />
      <DialogSelectModels />
      <DialogNewPrompt />
      <DialogPreview />
      <DialogSymbols />
      <DialogProgress />
      <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={changeLanguageEnglish('dialog', 'cleartemplatedata')}/>
      <AlertDialog alertYes={alertYesResponses} alertCancel={alertCancelResponse} openDialog = {openDialogResponse} closeDialog = {closeDialogBoxResponse} prompt={changeLanguageEnglish('dialog', 'clearresponse')}/>
      <AlertDialog alertYes={alertYesPrices} alertCancel={alertCancelPrices} openDialog = {openDialogPrices} closeDialog = {closeDialogBoxPrices} prompt={changeLanguageEnglish('stocks', 'refreshprices')}/>
      <AlertDialog alertYes={alertYesAnalyze} alertCancel={alertCancelAnalyze} openDialog = {openDialogAnalyze} closeDialog = {closeDialogBoxAnalyze} prompt={changeLanguageEnglish('stocks', 'refreshprices')} canceltext='No'/>
      <AlertDialog alertYes={alertYesDeleteSymbolsGroup} alertCancel={alertCancelDeleteSymbolsGroup} openDialog = {openDialogDeleteSymbolsGroup} closeDialog = {closeDialogBoxDeleteSymbolsGroup} prompt={changeLanguageEnglish('stocks', 'deletesymbolgroup')}/>
      <AlertDialog alertYes={alertYesFastAnalyze} alertCancel={alertCancelFastAnalyze} openDialog = {openDialogFastAnalyze} closeDialog = {closeDialogBoxFastAnalyze} prompt={changeLanguageEnglish('stocks', 'refreshprices')} canceltext='No'/>
     
    </div>
  )
}

export default StocksTemplates